import type { ShareInfo } from "./ChatPage.types";

const links = new Map<string, ShareInfo>();

// The API stores only a hash, so the original credential must stay client-side.
// Session storage keeps it available across navigation and reloads in this tab.
export function resolveShareInfo(id: string, info: ShareInfo): ShareInfo {
  const key = `lumen:conversation-share:${id}`;
  let cached = links.get(id);
  try {
    const stored = window.sessionStorage.getItem(key);
    if (!cached && stored) cached = JSON.parse(stored) as ShareInfo;
  } catch {
    // Sharing still works when browser storage is blocked or malformed.
  }

  const resolved = info.enabled
    ? {
        ...info,
        token:
          info.token ??
          (info.sharedAt &&
          cached?.sharedAt === info.sharedAt &&
          typeof cached.token === "string" &&
          /^lsh_[A-Za-z0-9_-]{43}$/.test(cached.token)
            ? cached.token
            : null),
      }
    : { ...info, token: null };

  if (resolved.token) links.set(id, resolved);
  else links.delete(id);
  try {
    if (resolved.token)
      window.sessionStorage.setItem(key, JSON.stringify(resolved));
    else window.sessionStorage.removeItem(key);
  } catch {
    // The in-memory cache also supports reopening without browser storage.
  }
  return resolved;
}
